module.exports = __webpack_public_path__ + "static/media/valor3.c403c755.jpg";